import React, { ComponentType, PureComponent, ReactNode } from 'react';
import Delay from './Delay';
import Preloader from './Preloader';

interface FetchComponentProps<Props = {}> {
  fetcher: () => Promise<{ default: ComponentType<Props> }>;
  placeholder?: ReactNode;
  delayMs: number;
  props: Props;
}

interface FetchComponentState {}

export default class FetchComponent<Props = {}> extends PureComponent<
  FetchComponentProps<Props>,
  FetchComponentState
> {
  public static defaultProps = {
    placeholder: null,
    delayMs: 500
  };

  public state = {};

  public render() {
    const { placeholder = null, fetcher, props, delayMs } = this.props;
    return (
      <Preloader
        fetcher={fetcher}
        render={({ loading, data, error }) => {
          if (!loading && !error && data) {
            const Component = data.default;
            return <Component {...props} />;
          }
          return (
            delayMs ? <Delay delayMs={delayMs} render={done => done && placeholder} /> : placeholder
          );
        }}
      />
    );
  }
}
